/**
 * @desc getAssociatedFile
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.AssociatedFileCategoryDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/getAssociatedFile`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
